import { gql } from '@apollo/client';

export const USER_DELETE_ONE = gql`
  mutation userDeleteOne($id: Int!) {
    userDeleteOne(id: $id) {
      id
    }
  }
`;
